/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {UserContext} from '@ion/core/src/services/MicroServices';
import {Users} from '@ion/core/src/types/entities';
import {BulkUserEditor} from '@ion/dls/src/editors/BulkUserEditor';
import {editAdminUsers, editUsers} from './state';
import {useAuthenticatedUser} from './useAuthenticatedUser';

export interface BulkEditUserEditorProps {
  context: UserContext
}
/**
 * @BulkEditUserEditor
 */
export const BulkEditUserEditor = ({context}: BulkEditUserEditorProps) => {
  const dispatch                           = useDispatch();
  const roles                              = useSelector(({adminUsers: {roles}}) => roles);
  const {globalGroup}                      = useSelector(({globalGroup}) => globalGroup);
  const {selected: selectedUsers, loading} = useSelector(({adminUsers: {bulkEdit}}) => bulkEdit);
  const currentUser                        = useAuthenticatedUser();

  return (
    <BulkUserEditor open
      users={selectedUsers}
      roles={roles}
      account={globalGroup || currentUser?.account}
      loading={loading}
      onSave={function(users: Users) {
        dispatch(editUsers(users, context));
      }}
      onCancel={function() {
        dispatch(editAdminUsers(null, false));
      }} />
  );
};

export default BulkEditUserEditor;
